import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=3d9a1d46&scoped=true&"
import script from "./Recommendations.vue?vue&type=script&lang=js&"
export * from "./Recommendations.vue?vue&type=script&lang=js&"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=3d9a1d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a1d46",
  null
  
)

/* custom blocks */
import block0 from "./Recommendations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports